import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const e = i((c, a) => /* @__PURE__ */ s.jsx(
  r,
  {
    ref: a,
    ...c,
    image: (l) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...l,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4145)", children: [
            /* @__PURE__ */ s.jsxs(
              "mask",
              {
                id: "mask0_2974_4145",
                width: 22,
                height: 32,
                x: 13,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: [
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M22.17 30.52c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97a.97.97 0 0 0-.97-.97M25.57 30.52c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97-.43-.97-.97-.97M23.87 27.19c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97a.97.97 0 0 0-.97-.97M23.87 33.84c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97a.97.97 0 0 0-.97-.97M20.41 33.84c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97-.43-.97-.97-.97M27.33 35.78c.54 0 .97-.43.97-.97s-.43-.97-.97-.97-.97.43-.97.97.43.97.97.97"
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M34.04 8H13.75c-.41 0-.75.34-.75.75v30.5c0 .41.34.75.75.75s.75-.34.75-.75V9.5h18.79v29.75c0 .41.34.75.75.75s.75-.34.75-.75V8.75c0-.41-.33-.75-.75-.75"
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M31.36 10.76c-.41 0-.75.34-.75.75V38.5H17.18V11.51c0-.41-.34-.75-.75-.75s-.75.34-.75.75v27.74c0 .41.34.75.75.75h14.92c.41 0 .75-.34.75-.75V11.51a.74.74 0 0 0-.74-.75"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4145)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M1.795 1.666h43.74v44.098H1.795z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4145", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
e.displayName = "AgencyPackagingIcon";
export {
  e as AgencyPackagingIcon,
  e as default
};
//# sourceMappingURL=index.js.map
